import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: import.meta.env.MODE === "development" ? "http://localhost:5001/api" : "/api",
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    
    // ⚠️ THIS IS THE FIX ⚠️
    // Only run this logic if the error is 401 AND it's NOT from the '/auth/check' route
    if (
      error.response?.status === 401 &&
      error.config.url !== "/auth/check"
    ) {
      // This is a "real" session expiry, not just a check
      localStorage.clear();
      window.location.href = '/login';
    }
    
    // Always reject the promise so the original function (like checkAuth)
    // can still catch the error and handle it.
    return Promise.reject(error);
  }
);

// Provide a default export for convenience (some files import default)
export default axiosInstance;